module.exports = __webpack_public_path__ + "img/what_mean_physio_splash.7003aa44.jpg";